import { HTTP } from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'SysParameter';

const systemParamUserStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0,
  },
  actions: {
    getSysParameter({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + '/qgl/listvalue', state.q)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    saveSysParam({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName,
            modelList: param.sysParamModel,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
  }
};
export default systemParamUserStore;